import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react'
import Button from 'devextreme-react/button'
import { Popup, ToolbarItem } from 'devextreme-react/popup'
import { useTranslation } from 'react-i18next'

export const Modal = forwardRef(({
  title,
  body,
  confirm,
  defaultOpened = false,
  hideCallback,
  modalProps = {},
  className = 'add-new-popup-wrap',
  width = 600,
  height = 'auto',
  hideOnOutsideClick = true
}, ref) => {
  const { t } = useTranslation()

  const [opened, setOpened] = useState(defaultOpened)
  const [innerData, setInnerData] = useState({
    title,
    body,
    confirm
  })

  const { title: innerTitle, body: innerBody, confirm: innerConfirm, modalProps: innerModalProps } = innerData

  useEffect(() => {
    setInnerData({ confirm, title, body })
  }, [title, body, confirm])

  const open = useCallback(() => {
    setOpened(true)
  }, [])

  const hide = useCallback((e) => {
    if (e?.event) {
      e.event.originalEvent?.stopPropagation()
    }

    setOpened(false)
    hideCallback && hideCallback()
    setInnerData({
      title: null,
      body: null,
      confirm: null,
      modalProps: null
    })
  }, [])

  useImperativeHandle(ref, () => {
    return {
      open,
      hide,
      setInnerData: (newData) => setInnerData((prevState) => ({ ...prevState, ...newData }))
    }
  }, [])

  return (
    <Popup
      width={width}
      height={height}
      visible={opened}
      onHiding={hide}
      animation={null}
      hideOnOutsideClick={hideOnOutsideClick}
      showCloseButton
      title={innerTitle}
      wrapperAttr={{
        class: className
      }}
      {...innerModalProps}
    >
      {innerBody}

      <ToolbarItem
        toolbar='bottom'
        location='before'
        cssClass='popup-footer-wrap'
      >
        <Button
          className='mr-2'
          onClick={hide}
          stylingMode='outlined'
          text={t('ui.close')}
        />
        <Button
          onClick={innerConfirm}
          stylingMode='contained'
          className='!text-white !bg-accessGold'
          text={innerModalProps?.confirmButtonText ?? t('ui.confirm')}
          visible={!innerModalProps?.hideConfirmButton}
        />
      </ToolbarItem>
    </Popup>
  )
})
